import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { SuiContainer } from '@splashthat/sui';
import { containerPaddingM } from 'common/styles/variables';

export const ButtonSeparator = styled.div`
    margin: 0 ${containerPaddingM};
    width: 1px;
    height: 32px;
    background-color: ${({ theme }) => theme.palette.grayscale.gray10};
`;

export const StyledCloseIcon = styled(Link)`
    padding: 10px;
    color: ${({ theme }) => theme.palette.grayscale.black};

    &:hover {
        color: ${({ theme }) => theme.palette.grayscale.gray50};
    }

    svg {
        height: 1rem;
        width: 1rem;
    }
`;

export const TopbarPreview = styled(SuiContainer)`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
`;
